import React, { useEffect, useState, useContext } from 'react'
import mainContext from '../../contexts/mainContext'
import { __constants, __snackBarText, __snackBarSeverity } from '../../constants';
import { getUserPaymentList, getWithdrawRequest } from '../../Controllers/Payments';
import { Divider, Pagination, styled } from '@mui/material';
import moment from 'moment';
import SearhcBar from './SearchBar';
import { useNavigate } from 'react-router-dom';

export default function WithdrawRequest() {
    const { setProfileNavTitle, setPageload } = useContext(mainContext);
    const [state, setState] = useState({ withdraw: [], total: 0 })
    const [filterState, setFilterState] = React.useState({});
    const navigate = useNavigate()
    useEffect(() => {
        setProfileNavTitle("Withdraw requests");
        fetchRequests(1)
    }, [])



    const fetchRequests = async (page, isClear) => { /* Handling api call */
    setPageload(true)
        let params = { page }
        if (!isClear)
            params = { page, ...filterState }

        const res = await getWithdrawRequest(params)
        setPageload(false)
        if (res.data.status === 200) {
            setState({ ...state, ...res.data.data })
        }
    }

    return (
        <React.Fragment>
            <SearhcBar paymentFilter={false} placeholder={"Enter withdraw no"} filterState={filterState} setFilterState={setFilterState} callFunction={fetchRequests} />

            <Container className='scrollbar'>
                <Body>

                    <Divider className='divider-gap' />
                    <List>
                        <div className="header">Status</div>
                        <div className="header">Withdraw No.</div>
                        <div className="header">Provider</div>
                        <div className="header">Name</div>
                        <div className="header">Email</div>
                        <div className="header">Mobile No</div>
                        <div className="header">Raise on</div>
                        <div></div>
                    </List>
                    <Divider className='divider-gap' />

                    {state.withdraw.map((object) => <List key={object._id}>
                        <div>
                            <div className={object.status === "Pending" ? "list_card_status status_inactive" : object.status === "Paid" ? "list_card_status status_active" : "list_card_status status_sleeping"}>{object.status}</div>
                        </div>
                        <div>
                            {object.withdrawNo}
                        </div>
                        <div>
                            {object.userInfo[0].role}
                        </div>
                        <div>
                            {object.userInfo[0].firstName} {object.userInfo[0].lastName}
                        </div>
                        <div>
                            {object.userInfo[0].email}
                        </div>
                        <div>
                            {object.userInfo[0].mobileNo}
                        </div>

                        <div>
                            {moment(object.createdAt).format("DD MMM, YYYY")}
                        </div>
                        {["Pending", "Unpaid"].includes(object.status) ?
                            <button className="list_card_view_btn" onClick={() => navigate('/payments/user?userId=' + object.userInfo[0]._id + "&role=" + object.userInfo[0].role)}>Pay Now</button> :
                            <div></div>
                        }
                    </List>
                    )}

                    <Divider className='divider-gap' />


                    {state.withdraw.length === 0 && <div className='no-record'><span>No Record Found</span></div>}
                </Body>
            </Container>
            {
                state.withdraw.length > 0 &&
                <>
                    <Pagination count={Math.ceil(state.total / __constants.listingLimit)} color="primary" shape="rounded" onChange={(e, page) => { fetchRequests(page) }} />
                    <br />
                </>
            }
        </React.Fragment>
    )
}


const Container = styled("div")`
  .divider-gap{
        margin: 0.5rem 0;
  }
  button{
    text-transform: none;
  }
  overflow-x: auto;
  margin-bottom:10px;

`;

const Body = styled("div")`
  height: 80vh;
  width:1100px;
  margin-bottom:10px;
`;

const Date = styled("div")`
  margin:20px 0px 10px 0;
  font-weight : bold;
`;

const List = styled("div")`
.header{
    font-family: "semi-bold";
}
  margin-top: 1rem;
  display: grid;
  column-gap: 0.7rem;
  grid-template-columns: minmax(0,1fr) minmax(0,1.4fr)  minmax(0,1.4fr) minmax(0,2fr) minmax(0,2.8fr) minmax(0,1.3fr) minmax(0,1.5fr)  minmax(0,1fr) ;
  align-items: center;
  font-size:14px
`;